import "../../../od.globalize.js";
import "../../../od.dates.js";

import {
  ClearChecks,
  digitsOnly,
  integerOnly,
  alphaOnly,
  usernameOnly,
  initAddToCartQuantityBox,
  GetDynamicTranslation,
  restrictInput,
  RemoveNonAlphaNumeric,
  isValidKeyInput,
  AddAntiForgeryToken,
  AddAntiForgeryTokenToForm,
  GetQueryStringParam,
  DecodeURIComponentWithSpaces,
  isEmail,
  cleanHtmlFromTerm,
  isPositiveInt,
  color,
} from "../../src/Legacy/common_functions.ts";

import { WebtrackContainer } from "../../src/Legacy/od-webtrack.ts";

import {
  wireUpFancyBoxModals,
  GetFancyboxArgumentObject,
} from "../../../fancyboxExtensions.js";

//common_functions
window.ClearChecks = ClearChecks;
window.digitsOnly = digitsOnly;
window.integerOnly = integerOnly;
window.alphaOnly = alphaOnly;
window.usernameOnly = usernameOnly;
window.initAddToCartQuantityBox = initAddToCartQuantityBox;
window.GetDynamicTranslation = GetDynamicTranslation;
window.restrictInput = restrictInput;
window.RemoveNonAlphaNumeric = RemoveNonAlphaNumeric;
window.isValidKeyInput = isValidKeyInput;
window.AddAntiForgeryToken = AddAntiForgeryToken;
window.AddAntiForgeryTokenToForm = AddAntiForgeryTokenToForm;
window.GetQueryStringParam = GetQueryStringParam;
window.DecodeURIComponentWithSpaces = DecodeURIComponentWithSpaces;
window.isEmail = isEmail;
window.cleanHtmlFromTerm = cleanHtmlFromTerm;
window.isPositiveInt = isPositiveInt;
window.color = color;

// od-webtrack
window.WebtrackContainer = WebtrackContainer;

// fancybox
window.wireUpFancyBoxModals = wireUpFancyBoxModals;
window.GetFancyboxArgumentObject = GetFancyboxArgumentObject;
